module.exports = __webpack_public_path__ + "assets/img/title-8581fb43.png";